<template>
    <div>
        <div class="border-r border-solid border-gray-200 pr-4 ">
            <div class="relative mx-0 rounded transition-all px-3 ease-linear delay-200 min-w-full"
              :class="getCaseData?.case_due_date ? 'cusror-pointer hover:bg-gray-100': 'cursor-not-allowed'"
              @click="showCaseDueDateDetail">
                <div class="rounded-md flex justify-around gap-2 items-center">
                    <div>
                        <div class="text-base-content-300 text-sm tracking-wide pb-2">{{ $t('case_creation.case_due_date') }}</div>
                        <div class="text-base font-medium tracking-wide text-base-content flex items-center">
                            {{ caseDueDate}}
                        </div>
                    </div>
                    <font-awesome-icon icon="chevron-down" />
                </div>				
            </div>
        </div>

        <CaseDueDateBreakdown
            v-if="caseEntityList.length > 1"
            :caseTypeEntityId="caseEntity?.id"
            :caseEntities="caseEntityList"
        />
    </div>
</template>

<script>
// ! Is dependent on Vuex data

import { mapGetters, mapActions } from "vuex";
import {
  CaseDueDateBreakdown,
} from "@shared/case-creation/CaseCreationFlow/components";
import { DateTime } from "luxon";

export default {
  components: {
    CaseDueDateBreakdown,
  },
  props: {
    case_id: {
      type: String,
      required: true,
    },
    caseEntityList: {
      type: Array,
      default: () => [],
    },
    caseEntity: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(["getCaseData"]),

    caseDueDate() {
      return this.getCaseData?.case_due_date ? DateTime.fromISO(this.getCaseData.case_due_date).toFormat("dd MMM yyyy") : '--';
    },
  },
  methods: {
    ...mapActions({
        toggleCaseDueDateModal: "CaseCreationStore/toggleCaseDueDateModal",
    }),
    showCaseDueDateDetail() {
        if (!this.getCaseData?.case_due_date) return;
        this.toggleCaseDueDateModal();
    }
  }
}
</script>

<style lang="scss" scoped>

</style>